// src/pages/media/PistonSection2.jsx
import { useRef, useLayoutEffect } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import pistonImage from '../../assets/images/multiturbine1.jpg'

gsap.registerPlugin(ScrollTrigger)

export default function MultiTurbineSection6() {
  const sectionRef = useRef(null)
  const pinRef     = useRef(null)
  const overlayRef = useRef(null)
  const contentRef = useRef(null)

useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger:       sectionRef.current,
          start:         'top top',
          end:           'bottom top',
          scrub:         true,            // buttery smooth
          pin:           pinRef.current,  // pin that 100vh container
          pinSpacing:    false,
          anticipatePin: 0.5
        }
      })

      // darken + slide/fade-in text together
      tl.to(overlayRef.current, {
        opacity: 0.9,
        ease:    'none',
        duration: 1
      }, 0)
      .fromTo(contentRef.current,
        { y: 100, opacity: 0 },
        { y: 0, opacity: 1, ease: 'none', duration: 0.4 },
        0
      )
    }, sectionRef)

    return () => ctx.revert()
  }, [])

  return (
    <section
      ref={sectionRef}
      className="relative h-[200vh] w-full overflow-hidden bg-black"
    >
      {/* pinned 100vh container */}
      <div
        ref={pinRef}
        className="sticky top-0 h-screen w-full overflow-hidden"
      >
        <img
          src={pistonImage}
          alt="Highlight Your Interiors"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* dark gradient */}
        <div
          ref={overlayRef}
          className="absolute inset-0 bg-gradient-to-b from-black/80 to-black opacity-0 pointer-events-none"
        />

        {/* CONTENT: left-aligned, with logo-gutter spacing */}
        <div
          ref={contentRef}
          className="
            relative z-20 h-full
            flex flex-col justify-center
            items-start
            px-6 py-2        /* mobile gutter */
            md:px-8          /* tablet+ gutter */
            text-white text-left
          "
        >
          <h2 className="text-5xl md:text-6xl font-bold mb-4">
            Sell with Confidence
          </h2>
          <p className="text-xl md:text-2xl max-w-lg leading-relaxed">
            Our aircraft interiors are built with precision, comfort, and sleek finishes—perfectly suited for elevated missions.
          </p>
        </div>
      </div>
    </section>
  )
}